import { Firestore } from "../lib/firebase";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

toast.configure({
  autoClose: 2000,
  draggable: false
});

const SUPPLIERS_TABLE_NAME = "suppliers";

export function getSuppliers(country) {
  return Firestore.collection(SUPPLIERS_TABLE_NAME)
    .where("market", "==", country)
    .get()
    .then((results) => results.docs.map((size) => size.data()))
    .catch((error) => {
      throw new Error(error);
    });
}
export async function getSupplierById(id) {
  try {
    return Firestore.collection(SUPPLIERS_TABLE_NAME)
    .doc(id)
    .get()
    .then((docRef) => { return docRef.data() })
      .catch((error) => { 
        throw new Error(error);
    })
  
} catch (error) {
  throw error;
}
}

export function deleteSupplierById(id, setData,isDeleting,setIsDeleting) {

  if (isDeleting) {
    return;
  }

  setIsDeleting(true);

  const docRef = Firestore.collection(SUPPLIERS_TABLE_NAME).doc(id);

  docRef.delete()
    .then(() => {
      setData(prevData => prevData.filter(item => item.id !== id));
      toast.success("Supplier deleted successfully!", {
        position: toast.POSITION.TOP_LEFT
      });
    })
    .catch((error) => {
      console.error("Error removing document: ", error);
    })
    .finally(() => {
      setIsDeleting(false);
    });
}

export const setNewSupplier = async (payload,setData,inputText,setInputText,id,setIsLoading,isLoading) => {
  try {

     // Check if already loading or if an error has occurred
     if (isLoading) {
      return;
    }
    setIsLoading(true); 
    const loadingFunc = () => {
      setIsLoading(false)
    }

      // Check if the garment value already exists in Firestore
      const existingDoc = await Firestore.collection(SUPPLIERS_TABLE_NAME)
        .where('value', '==', payload.value)
        .where('market', '==', payload.market)
      .get();
  
    if (!existingDoc.empty) {
      toast.error("Supplier already exists", {
        position: toast.POSITION.TOP_LEFT
      });
      setTimeout(loadingFunc, 2000);

      return;
    }
      await Firestore.collection(SUPPLIERS_TABLE_NAME).doc(payload.id)
      .set(payload)
      .then(() => {
        setData(prevData => [...prevData, { id: id, value: inputText, label: inputText }]);
        setInputText("");
        setTimeout(loadingFunc, 2000);
        toast.success("Supplier created successfully!", {
          position: toast.POSITION.TOP_LEFT
        });
        
    })
    
  } catch (error) {
    toast.error(error.message, { position: toast.POSITION.TOP_LEFT });
  }
};
export const update = async (payload,history) => {
  try {
    // Check if the garment value already exists in Firestore
    const existingDoc = await Firestore.collection(SUPPLIERS_TABLE_NAME)
      .where('value', '==', payload.value)
      .get();

    if (!existingDoc.empty) {
      toast.error("Supplier already exists", {
        position: toast.POSITION.TOP_LEFT
      });
      return;
    }

    await Firestore.collection(SUPPLIERS_TABLE_NAME)
      .doc(payload.id)
      .set(payload)
      .then(() => {
        history.goBack()
        toast.success("Supplier updated successfully!", {
          position: toast.POSITION.TOP_LEFT
        });
      });
  } catch (error) {
    toast.error(error.message, { position: toast.POSITION.TOP_LEFT });
  }
};


